// Note: When updating the following list you need to verify if the recipient email list in
// https://github.com/RocheGlobal/Roche-XX-Forms-Api/blob/develop/src/contact_form/process-contact-form-interactor.ts
// is still working.
export const formSubjectList = [
  'IT information security',
  'Sustainability',
  'Environmental Protection, Occupational Health and Safety, Security',
  'Other',
];
